<template>
  <div class="px-4 py-5 text-center box-container">
    <div class="subtitle1">{{ title }}</div>
    <div class="subtitle2 mt-4">{{ subtitle }}</div>
  </div>
</template>

<script lang="ts" setup>
defineProps<{ title: string; subtitle: string }>()
</script>
